import { useMemo, useEffect } from 'react';
import HomePage from './pages/home/HomePage';
import { Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { themeSettings } from './theme';
import AppInitializer from './AppInitializer';
import styles from './App.module.css';
import Blog from './pages/blog/Blog';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CreatePost from './pages/CreatePost';
import PostPage from './pages/PostPage';
import EditPage from './pages/EditPage';
import { useSelector } from 'react-redux';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/dashboard';
import Products from './pages/products';
import Customers from './pages/customers';
import Transactions from './pages/transactions';
import Geography from './pages/geography';
import Overview from './pages/overview';
import Daily from './pages/daily';
import Monthly from './pages/monthly';
import Breakdown from './pages/breakdown';
import Admin from './pages/admin';
import Performance from './pages/performance';
// import ClientLayout from './components/Layout/ClientLayout';
import ClientDashboard from './pages/ClientDashboard/ClientDashboard';
import CreateDevice from './pages/CreateDevice';
import BlogAdmin from './pages/blogAdmin';
import BlogCreatePost from './pages/blogAdmin/BlogCreatePost';
import BlogEditPost from './pages/blogAdmin/BlogEditPost';
import { useDispatch } from 'react-redux';
import { setUserInfo, clearUserInfo } from './state';
import { useGetProfileQuery } from './state/api';

function App() {
  const dispatch = useDispatch();
  const { data, isLoading, isError } = useGetProfileQuery();
  const mode = useSelector((state: any) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  useEffect(() => {
    if (data) {
      dispatch(setUserInfo(data)); // uložíme usera
    }
    if (isError) {
      dispatch(clearUserInfo());
    }
  }, [data, isError, dispatch]);

  if (isLoading) return <p>Načítám...</p>;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppInitializer />
      <div className={styles.content}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog/*" element={<Blog />}></Route>
          {/*Layout for users */}
          <Route path="/" element={<Layout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/create" element={<CreatePost />} />
            <Route path="/post/:id" element={<PostPage />} />
            <Route path="/edit/:urlTitle" element={<EditPage />} />
          </Route>
          {/* Layout for Clients */}
          <Route path="/client/:id" element={<Layout />}>
            <Route index element={<ClientDashboard />} />
            {/* <Route path="settings" element={<ClientSettings />} /> */}
            {/* /client/123 → ClientLayout se vykreslí, uvnitř se zobrazí ClientDashboard.
              /client/123/settings → stejné ClientLayout, ale zobrazí se ClientSettings. */}
            {/* další subpages */}
          </Route>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/geography" element={<Geography />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/daily" element={<Daily />} />
            <Route path="/monthly" element={<Monthly />} />
            <Route path="/breakdown" element={<Breakdown />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/create-device" element={<CreateDevice />} />
            <Route path="/blog-admin" element={<BlogAdmin />} />
            <Route path="/blog-admin/create" element={<BlogCreatePost />} />
            <Route path="/blog-admin/edit/:urlTitle" element={<BlogEditPost />} />
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
